"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import SwiperCore from "swiper";
import { Pagination, Autoplay } from "swiper/modules";
import Image from "next/image";

SwiperCore.use([Pagination, Autoplay]);

export default function SocialMediaArea() {
	return (
		<section className="mt-2 py-16 md:py-20 lg:pb-28 lg:pt-24 xl:pt-32">
			<div className="container xl:max-w-[1230px]">
				<div className="section-title mb-10 space-y-4 text-center md:mb-14 md:space-y-6">
					<h2>Social Media Management</h2>
					<p className="mx-auto max-w-[550px] text-sm sm:text-base lg:max-w-[686px]">
						Master Your Social Presence with Ease
					</p>
				</div>
				<div className="xl:gap-7.5 grid gap-5 md:grid-cols-3">
					<div className="space-y-5 rounded-lg bg-[#F5F8FFCC] p-5 lg:px-6 lg:py-5 xl:px-11 xl:py-9">
						<Image
							src="/marketing/assets/img/social-media/objective-icon.svg"
							alt="objective-icon"
						/>
						<h3 className="text-title text-xl font-semibold md:text-lg lg:text-2xl">Objectives</h3>
						<ul className="space-y-4">
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="text-[#000D4980] md:text-sm lg:text-base">
									To establish your company the industry thought leader.
								</p>
							</li>
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="text-[#000D4980] md:text-sm lg:text-base">
									increase engagement and following.
								</p>
							</li>
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="text-[#000D4980] md:text-sm lg:text-base">
									Showcase real-time trends and relevant industry insights.
								</p>
							</li>
						</ul>
					</div>
					<div className="space-y-5 rounded-lg bg-[#F5F8FFCC] p-5 lg:px-6 lg:py-5 xl:px-11 xl:py-9">
						<Image
							src="/marketing/assets/img/social-media/manage-icon.svg"
							alt="manage-icon"
							className="mt-1"
						/>
						<h3 className="text-title text-xl font-semibold md:text-lg lg:text-2xl">
							Manage &amp; Track
						</h3>
						<ul className="space-y-4">
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="text-[#000D4980] md:text-sm lg:text-base">Weekly content calendar</p>
							</li>
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="text-[#000D4980] md:text-sm lg:text-base">
									Varied content mix, including carousels, infographics, and reels
								</p>
							</li>
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="md:tmd:ext-sm text-[#000D4980] lg:text-base">
									Posts are scheduled to reach your target audience
								</p>
							</li>
						</ul>
					</div>
					<div className="space-y-5 rounded-lg bg-[#F5F8FFCC] p-5 lg:px-6 lg:py-5 xl:px-11 xl:py-9">
						<Image src="/marketing/assets/img/social-media/creative-icon.svg" alt="creative-icon" />
						<h3 className="text-title text-xl font-semibold md:text-lg lg:text-2xl">
							Collaterals/Creatives
						</h3>
						<ul className="space-y-4">
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="text-[#000D4980] md:text-sm lg:text-base">
									High-quality, visually appealing graphics and visuals to accompany each post.
								</p>
							</li>
							<li className="flex items-start gap-2.5">
								<Image
									src="/marketing/assets/img/icon/check-rounded.svg"
									alt="check icon"
									className="mt-1"
								/>
								<p className="text-[#000D4980] md:text-sm lg:text-base">
									Consistent branding elements to reinforce brand identity.
								</p>
							</li>
						</ul>
					</div>
				</div>
				{/* social media slider start */}
				<div className="social-media-slider swiper my-16 lg:my-20 xl:my-24">
					<Swiper
						pagination={{ clickable: true }}
						spaceBetween={20}
						slidesPerView={3}
						loop={true}
						speed={1000}
						autoplay={{ delay: 3500 }}
						breakpoints={{
							0: { slidesPerView: 1 },
							640: { slidesPerView: 2 },
							768: { slidesPerView: 3 },
							1200: { spaceBetween: 32 },
						}}
					>
						<SwiperSlide className="swiper-slide group overflow-hidden rounded-xl">
							<Image
								src="/marketing/assets/img/social-media/media-slider-thumb-1.svg"
								alt="slider thumb"
								className="w-full rounded-xl transition-all duration-1000 group-hover:scale-110"
							/>
						</SwiperSlide>
						<SwiperSlide className="swiper-slide group overflow-hidden rounded-xl">
							<Image
								src="/marketing/assets/img/social-media/media-slider-thumb-2.svg"
								alt="slider thumb"
								className="w-full rounded-xl transition-all duration-1000 group-hover:scale-110"
							/>
						</SwiperSlide>
						<SwiperSlide className="swiper-slide group overflow-hidden rounded-xl">
							<Image
								src="/marketing/assets/img/social-media/media-slider-thumb-3.svg"
								alt="slider thumb"
								className="w-full rounded-xl transition-all duration-1000 group-hover:scale-110"
							/>
						</SwiperSlide>
						<SwiperSlide className="swiper-slide group overflow-hidden rounded-xl">
							<Image
								src="/marketing/assets/img/social-media/media-slider-thumb-1.svg"
								alt="slider thumb"
								className="w-full rounded-xl transition-all duration-1000 group-hover:scale-110"
							/>
						</SwiperSlide>
					</Swiper>
					<div className="swiper-pagination !bottom-0 !top-auto" />
				</div>
				{/* social media slider end */}
				{/* video-&-youtube-management start */}
				<div>
					<div className="section-title mb-10 space-y-4 pb-2 text-center md:mb-16 md:space-y-5 lg:mb-20">
						<h2>Videos &amp; YouTube</h2>
						<p className="mx-auto max-w-[550px] text-sm sm:text-base lg:max-w-[686px]">
							Streamline Your YouTube and Video Editing Needs
						</p>
					</div>
					<div className="flex flex-col gap-10 md:gap-16 lg:gap-[88px]">
						<div className="grid items-center gap-10 md:grid-cols-2 md:gap-5 lg:gap-8 xl:gap-24">
							<div className="rounded-[30px] bg-[#E0E8F8] px-6 py-5 lg:px-10 lg:py-8 xl:px-14 xl:py-11">
								<Image
									src="/marketing/assets/img/social-media/youtube-manage-thumb.jpg"
									alt="ad thumb"
									className="w-full rounded-[20px]"
								/>
							</div>
							<div>
								<h3 className="text-title mb-6 text-xl font-bold capitalize leading-normal lg:text-2xl xl:mb-10 xl:text-[32px]">
									YouTube Management
								</h3>
								<ul className="space-y-4 capitalize">
									<li className="flex items-start gap-3.5">
										<Image
											src="/marketing/assets/img/icon/check-rounded.svg"
											alt="check icon"
											className="mt-1"
										/>
										<p className="text-base text-[#000D49B2] xl:text-lg">
											Uploading videos provided by client
										</p>
									</li>
									<li className="flex items-start gap-3.5">
										<Image
											src="/marketing/assets/img/icon/check-rounded.svg"
											alt="check icon"
											className="mt-1"
										/>
										<p className="text-base text-[#000D49B2] xl:text-lg">
											Implementing on-page SEO best practices, including relevant
											keywords,compelling thumbnails, and engaging video descriptions.
										</p>
									</li>
									<li className="flex items-start gap-3.5">
										<Image
											src="/marketing/assets/img/icon/check-rounded.svg"
											alt="check icon"
											className="mt-1"
										/>
										<p className="text-base text-[#000D49B2] xl:text-lg">
											Creating Thumbnails for the videos provided
										</p>
									</li>
									<li className="flex items-start gap-3.5">
										<Image
											src="/marketing/assets/img/icon/check-rounded.svg"
											alt="check icon"
											className="mt-1"
										/>
										<p className="text-base text-[#000D49B2] xl:text-lg">
											Doesn&apos;t include video editing
										</p>
									</li>
								</ul>
							</div>
						</div>
						<div className="grid items-center gap-10 md:grid-cols-2 md:gap-5 lg:gap-8 xl:gap-24">
							<div className="order-1 rounded-[30px] bg-[#E0E8F8] pl-8 pt-11 md:order-2">
								<Image
									src="/marketing/assets/img/social-media/video-editing-thumb.png"
									alt="video thumb"
									className="w-full rounded-br-[30px]"
								/>
							</div>
							<div className="order-2 md:order-1">
								<h3 className="text-title mb-6 text-xl font-bold capitalize leading-normal lg:text-2xl xl:mb-10 xl:text-[32px]">
									Video Editing
								</h3>
								<ul className="space-y-4 capitalize">
									<li className="flex items-start gap-3.5">
										<Image
											src="/marketing/assets/img/icon/check-rounded.svg"
											alt="check icon"
											className="mt-1"
										/>
										<p className="max-w-96 text-base text-[#000D49B2] xl:text-lg">
											Creating concepts + editing raw videos provided by the client
										</p>
									</li>
									<li className="flex items-start gap-3.5">
										<Image
											src="/marketing/assets/img/icon/check-rounded.svg"
											alt="check icon"
											className="mt-1"
										/>
										<p className="max-w-[410px] text-base text-[#000D49B2] xl:text-lg">
											Based on campaign and requirements, such as client testimonials, founder
											videos,product demos or expert collabs.
										</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				{/* video-&-youtube-management end */}
			</div>
		</section>
	);
}
